import { render, staticRenderFns } from "./SidebarStickyButtons.vue?vue&type=template&id=4996410d&scoped=true&"
import script from "./SidebarStickyButtons.vue?vue&type=script&lang=js&"
export * from "./SidebarStickyButtons.vue?vue&type=script&lang=js&"
import style0 from "./SidebarStickyButtons.vue?vue&type=style&index=0&id=4996410d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4996410d",
  null
  
)

export default component.exports